import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Alert, Container, Button, Col, Row } from 'react-bootstrap';

import './Styles.css';

import { fetchAuthMe } from './AuthMe';
import { Auth, Event } from '../../support';

class SessionOverrideHighlighter extends Component {
  state = {};

  constructor(props) {
    super(props);

    const data = Auth.getData();

    this.state = {
      override: !!data.override
        ? {
            ...data.override,
            empresa: undefined,
          }
        : undefined,
      data: {
        ...data.cliente,
      },
      redirect: false,
    };
  }

  componentDidMount() {
    Event.on('app.refresh', this.listenForGlobalAppRefresh);
  }

  componentWillUnmount() {
    Event.off('app.refresh', this.listenForGlobalAppRefresh);
  }

  listenForGlobalAppRefresh = () => {
    const data = Auth.getData();

    this.setState({
      override: data.override,
    });
  };

  handleOnSessionBack = async () => {
    const original = Auth.getData();
    const { override } = original;

    const overrideCliente = { ...override };

    delete overrideCliente['empresa'];

    const newData = {
      token: override.token,
      user: original.user || {},
      empresa: override.empresa || {},
      emisor: original.emisor || {},
      cliente: overrideCliente || {},
    };

    await Auth.setData(newData);

    const profile = await fetchAuthMe({
      headers: {
        'X-Tenancy': 'fa/live',
      },
    });

    /**
     * TODO
     * Revisar porque no regresa el cliente de auth/me el que está en sessión
     */
    const { emisor } = profile.data;

    const data = {
      ...newData,
      empresa: {
        ...override.empresa,
      },
      emisor: emisor || {},
      cliente: {
        ...override,
        empresa: undefined,
      },
      override: undefined,
    };

    await Auth.setData(data);

    await window.resetApp();

    this.setState({
      redirect: true,
    });
  };

  render() {
    const { data, override, redirect } = this.state;

    if (redirect) {
      return <Redirect to="/bridge" />;
    }

    if (!override) {
      return null;
    }

    return (
      <Alert variant="warning">
        <Container
          fluid={false}
          className="bg-transparent"
        >
          <Row>
            <Col className="session-highlight-company">
              <strong>{data.nombre_comercial}</strong>
            </Col>
            <Col className="text-right">
              <Button
                variant="link"
                onClick={this.handleOnSessionBack}
              >
                Salir
              </Button>
            </Col>
          </Row>
        </Container>
      </Alert>
    );
  }
}

export default SessionOverrideHighlighter;
